const ShipmentsUtils = {
    sameStores: (a, b) => !!(a.attributes && b.attributes
        && a.attributes.store_ids && b.attributes.store_ids
        && a.attributes.store_ids.length >= 1 && b.attributes.store_ids.length >= 1
        && a.attributes.store_ids[0] === b.attributes.store_ids[0]),

    compareShipments: (a, b) => ((!ShipmentsUtils.sameStores(a, b)) ? a.attributes.store_ids[0] - b.attributes.store_ids[0] : 0),

    prevIsSameStore: (shipments, idx) => (idx === 0 ? false : ShipmentsUtils.sameStores(shipments[idx - 1], shipments[idx])),

    nextIsSameStore: (shipments, idx) => !!(idx !== shipments.length - 1 && ShipmentsUtils.sameStores(shipments[idx], shipments[idx + 1])),

    countAmountOfStores: (shipments) => {
        const storeIds = shipments.map((shipment) => shipment.attributes.store_ids[0]);
        // count the number of same store ids
        return storeIds.reduce((acc, curr) => {
            acc[curr] = (acc[curr] || 0) + 1;
            return acc;
        }, {});
    },

    shipmentStylePadding: (shipments, idx, prevStyle = {}) => {
        const style = { ...prevStyle };
        if (ShipmentsUtils.nextIsSameStore(shipments, idx)) {
            style.paddingBottom = '0px';
        }
        if (ShipmentsUtils.prevIsSameStore(shipments, idx)) {
            style.paddingTop = '0px';
        }

        return style;
    },
};

export default ShipmentsUtils;



/** WEBPACK FOOTER **
 ** ./src/services/shipments-utils.js
 **/